export default __webpack_public_path__ + "static/media/icons-delete-18-px.51e70063.svg";